// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"41":"error","328":"admin","620":"collections","767":"details"}[chunkId] + "." + {"41":"ee486c7c","328":"1b470bec","620":"ff7fd310","767":"956b368a"}[chunkId] + ".js";
};